import { AbstractControl, ValidationErrors } from '@angular/forms';
export function noSeriesStartEndEndValidator(control: AbstractControl): ValidationErrors | null {
    const start = Number(control.get('startingSequenceNumber')?.value||0);
    const end = Number(control.get('endingSequenceNumber')?.value||0);

    if (start && end && (start > end)) {
        return { numberRangeInvalid: true };
    }
    return null;
}
